import initialState from "./initialState.json"
import {getPortal} from "../index"

// TYPES
export const FINISH_UPLOAD = "FINISH_UPLOAD"
export const START_UPLOAD = "START_UPLOAD"

// SELECTORS
export const getPortalDocuments = (state) => getPortal(state).documents

// 1
export const getPortalDocument = (state, id) => {
  return getPortalDocuments(state).find(document => document.id === id)
}

// CREATORS
export const finishUpload = id => ({type: FINISH_UPLOAD, id})
export const startUpload = document => ({type: START_UPLOAD, document})

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case START_UPLOAD:
      return [action.document, ...state]
    default:
      return state
  }
}
